// @ts-nocheck
import React, { useState, useEffect } from 'react';
import { Wifi, WifiOff, AlertCircle, CheckCircle, RefreshCw } from 'lucide-react';
import { checkApiConnectivity, API_CONFIG } from '../config/api';
import './ApiDiagnostic.css';

const ApiDiagnostic = () => {
  const [connectivityStatus, setConnectivityStatus] = useState(null);
  const [loading, setLoading] = useState(false);
  const [lastCheck, setLastCheck] = useState(null);

  const checkConnectivity = async () => {
    setLoading(true);
    try {
      const status = await checkApiConnectivity();
      setConnectivityStatus(status);
      setLastCheck(new Date());
    } catch (error) {
      setConnectivityStatus({
        status: 'error',
        error: error.message
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    checkConnectivity();
  }, []);

  const getStatusIcon = () => {
    if (loading) return <RefreshCw size={20} className="animate-spin" />;
    
    switch (connectivityStatus?.status) {
      case 'connected':
        return <CheckCircle size={20} className="text-green-500" />;
      case 'error':
        return <AlertCircle size={20} className="text-yellow-500" />;
      case 'unreachable':
        return <WifiOff size={20} className="text-red-500" />;
      default:
        return <Wifi size={20} className="text-gray-400" />;
    }
  };

  const getStatusText = () => {
    if (loading) return 'Vérification en cours...';
    
    switch (connectivityStatus?.status) {
      case 'connected':
        return 'API connectée';
      case 'error':
        return `Erreur API (${connectivityStatus.statusCode})`;
      case 'unreachable':
        return 'API inaccessible';
      default:
        return 'Statut inconnu';
    }
  };

  const getStatusColor = () => {
    switch (connectivityStatus?.status) {
      case 'connected':
        return 'text-green-600';
      case 'error':
        return 'text-yellow-600';
      case 'unreachable':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  return (
    <div className="api-diagnostic">
      <div className="diagnostic-header">
        <h3>Diagnostic API</h3>
        <button 
          onClick={checkConnectivity}
          disabled={loading}
          className="refresh-button"
        >
          <RefreshCw size={16} className={loading ? 'animate-spin' : ''} />
        </button>
      </div>

      <div className="diagnostic-content">
        <div className="status-row">
          <span className="status-icon">{getStatusIcon()}</span>
          <span className={`status-text ${getStatusColor()}`}>
            {getStatusText()}
          </span>
        </div>

        {connectivityStatus && (
          <div className="diagnostic-details">
            <div className="detail-row">
              <span className="detail-label">URL API:</span>
              <span className="detail-value">{API_CONFIG.API_BASE_URL}</span>
            </div>
            
            {connectivityStatus.responseTime && (
              <div className="detail-row">
                <span className="detail-label">Temps de réponse:</span>
                <span className="detail-value">{connectivityStatus.responseTime}ms</span>
              </div>
            )}

            {connectivityStatus.status === 'error' && (
              <div className="detail-row">
                <span className="detail-label">Code d'erreur:</span>
                <span className="detail-value">{connectivityStatus.statusCode}</span>
              </div>
            )}

            {connectivityStatus.status === 'unreachable' && (
              <div className="detail-row">
                <span className="detail-label">Erreur:</span>
                <span className="detail-value error-text">{connectivityStatus.error}</span>
              </div>
            )}

            {lastCheck && (
              <div className="detail-row">
                <span className="detail-label">Dernière vérification:</span>
                <span className="detail-value">
                  {lastCheck.toLocaleTimeString()}
                </span>
              </div>
            )}
          </div>
        )}

        {connectivityStatus?.status === 'unreachable' && (
          <div className="troubleshooting">
            <h4>Dépannage:</h4>
            <ul>
              <li>Vérifiez que le backend est démarré sur le port {API_CONFIG.BACKEND_PORT}</li>
              <li>Vérifiez que le frontend est configuré pour le bon port</li>
              <li>Vérifiez les logs du backend pour les erreurs</li>
              <li>Vérifiez que le CORS est configuré correctement</li>
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default ApiDiagnostic;